import { Component } from '@angular/core'

import { GenericListComponent } from '../../framework/generic-list/generic-list.component'
import { Zone, ZoneService } from '../zone.service'

@Component({
  selector: 'app-zone-list',
  templateUrl: './zone-list.component.html',
  styleUrls: ['../../framework/generic-list/generic-list.component.css']
})
export class ZoneListComponent extends GenericListComponent<Zone> {

  constructor(protected override service: ZoneService) { super(service) }
}
